import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash-es'
import { resetFptiTags, recordImpression } from 'utils/fpti'
import { serverData } from 'utils/server-data'
import useDeepCompareEffect from 'use-deep-compare-effect'
import { selectFptiData } from '@/features/ui/ui-slice'

/**
 * Record FPTI page impression.
 *
 * @data {object} - Additional FPTI tags
 * @param {boolean} [options.resetTags=true] - By dfeault additional tags passed to usePageImpression
 *    will be reset on subsequent page impression calls. But when tracking form/page error alert in a
 *    separate component, we still want to keep the previous page/pgrp values; in such use case,
 *    pass a false resetTags option
 */
export default function usePageImpression(data, options: any = {}) {
  // If page is not passed, they are usually form error impressions embedded inside
  // Form subcomponent, skip reset for such use case, so that it could reuse FPTI page
  // settings

  // Last FPTI data updated by xhr request before the page render
  const { calc } = useSelector(selectFptiData) || {}
  const fptiEntryPoint = useSelector((state: any) => state.entryPoint?.entryPointName)

  useDeepCompareEffect(() => {
    const defaultFptiData = serverData?.fpti || {}
    const { page, ...restFptiData } = data || {}
    const { resetTags = true } = options

    if (resetTags) {
      resetFptiTags()
    }

    let calcValue = {}
    if (calc) {
      calcValue = {
        calc,
      }
    }
    // Page render is usually associated with the last render of XHR call, override
    // debug Id with the last debug Id returned by last XHR for ease of debugging
    const fptiData = Object.assign({}, defaultFptiData, restFptiData, calcValue, { fptiEntryPoint })
    // To avoid page impressions without data
    if (!isEmpty(data)) {
      recordImpression(page, fptiData)
    }
  }, [data, options])
}
